<template>
  <div class="workOrder">
    <div class="header">
      <div class="context1">
        <div class="msg1">
          <span class="title">机组总数</span>
          <div class="chartNum">
            <div class="chartNumBian">
              <div class="box-item">
                      <li class="number-item"  v-for="(item,index) in orderNum" :key="index">
                          <span>{{item}}</span>
                        </li>
                    </div>
            </div>
          </div>
        </div>
        <div class="msg2"><span class="title">开机台数</span>
          <div class="chartNum">
            <div class="chartNumBian">
              <div class="box-item">
                      <li :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
                          v-for="(item,index) in powerNum" :key="index">
                          <span class="commas" ref="numberItem">{{item}}</span>
                        </li>
                    </div>
            </div>
          </div>
          <div class="progress">
            <div :style="{width:bootRecord+'%'}">
            </div>
          </div>
          <div class="progressImg">
            <img src="@/assets/arrow.png" />
          </div>
          <div class="progressWork">
            开机率 <span>{{bootRecord}}%</span>
          </div>
        </div>
      </div>
      <div class="pig">
        <div>按状态统计机组</div>
        <div class="edit" v-if="edit">
          <i class="el-icon-edit" @click="statisticsUnits"></i>
        </div>
        <div id="myChart1" :style="{width: '100%', height: '320px'}"></div>
      </div>
    </div>
    <div class="workOrder_footer">
      <div class="edit2" v-if="edit2">
        <i class="el-icon-edit" @click="generationTrend"></i>
      </div>
      <div id="myChart2" :style="{width: '100%', height: '400px'}"></div>
    </div>
  </div>
</template>

<script>

//职称结构图表
var xdata = ['维修', "保养", "异常", "正常"];
import * as echarts from 'echarts';
import axios from 'axios';
export default {
  data() {
    return {
      form2: {
        id: '',
        january: '',
        february: '',
        march: '',
        april: '',
        may: '',
        june: '',
        july: '',
        august: '',
        september: '',
        october: '',
        november: '',
        december: ''
      },
      dialogVisible: false,
      dialogVisible2: false,
      orderNum: [], // 默认机组总数
      powerNum: [], // 默认开机台数
      bootRecord: '',//开机率
      edit: false,
      edit2: false
    }
  },
  props: ['grewList'],
  watch: {
    grewList: function (newVal, oldVal) {
      console.log('grewList')
      this.drawLine()
    }
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      var that = this
      var order = []
      var power = []
      var syjgdata = []
      var dataList = []
      // 基于准备好的dom，初始化echarts实例
      let myChart = that.$echarts.init(document.getElementById('myChart1'))
      let myChart2 = that.$echarts.init(document.getElementById('myChart2'))
      axios.get('/api/powermis/bigScreen/getPlantUnit').then(response => {
        //机组总数
        for (var i = 0; i < (response.data.data.totalAndOnLineCountMap.totalCount).toString().length; i++) {
          order.push((response.data.data.totalAndOnLineCountMap.totalCount).toString()[i])
        }
        order.unshift('0')
        that.orderNum = order
        //开机台数
        if (response.data.data.totalAndOnLineCountMap.onLineCount == 0) {
          that.powerNum = [0, 0, 0, 0]
        } else {
          for (var i = 0; i < (response.data.data.totalAndOnLineCountMap.onLineCount).toString().length; i++) {
            power.push((response.data.data.totalAndOnLineCountMap.onLineCount).toString()[i])
          }
          power.unshift('0')
          that.powerNum = power
        }
        //开机率
        if (response.data.data.totalAndOnLineCountMap.onLineCount == 0) {
          that.bootRecord = 0
        } else {
          var bootRecord = (Number(response.data.data.totalAndOnLineCountMap.onLineCount) / Number(response.data.data.totalAndOnLineCountMap.totalCount)).toFixed(2);
          that.bootRecord = (Number(bootRecord) * 100).toFixed(2)
        }
        //按状态统计机数
        syjgdata = [{
          "name": "维修",
          "value": response.data.data.maintenanceStatusCountMap.repairProportion
        }, {
          "name": "保养",
          "value": response.data.data.maintenanceStatusCountMap.maintainProportion
        }, {
          "name": "异常",
          "value": response.data.data.maintenanceStatusCountMap.abnormalProportion
        }, {
          "name": "正常",
          "value": response.data.data.maintenanceStatusCountMap.normalProportion
        }]
        myChart.setOption(
          {
            legend: {
              orient: "horizontal",
              data: xdata,
              top: 10,
              x: 'center',
              itemWidth: 13,
              itemHeight: 8,
              itemGap: 16,
              textStyle: {
                color: '#FFFFFF'
              },
              formatter: function (name) {
                return '' + name
              }
            },
            series: [{
              itemStyle: {
                normal: {
                  color: function (params) {
                    //渐变色列表，自定义自己需要的颜色
                    var colorLists = [
                      {
                        c1: "#23A6C7",
                        c2: "#1CF185"
                      },
                      {
                        c1: "#21E754",
                        c2: "#FFEE5A"
                      },
                      {
                        c1: "#FFDF5F",
                        c2: "#FF5959"
                      },
                      {
                        c1: "#F95F83",
                        c2: "#D773B4"
                      },
                      {
                        c1: "#3494E6",
                        c2: "#EC6EAD"
                      }
                    ];
                    return new that.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
                      {
                        //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                        offset: 0,
                        color: colorLists[params.dataIndex].c1
                      },
                      {
                        offset: 1,
                        color: colorLists[params.dataIndex].c2
                      }
                    ]);
                  },
                  // ['rgba(63,227,236,0.3)'],
                  borderColor: '#5D6D7C',
                  borderWidth: 3
                }
              },
              type: 'pie',
              radius: ['25%', '58%'],
              center: ["50%", "50%"],
              labelLine: {
                normal: {
                  lineStyle: {
                    color: '#34569D'
                  }
                }
              },
              label: {
                normal: {
                  formatter: '{d}%',
                  textStyle: {
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 12
                  }
                }
              },
              data: syjgdata
            }, {
              itemStyle: {
                normal: {
                  color: '#13A7A2',
                }
              },
              type: 'pie',
              hoverAnimation: false,
              radius: ['35%', '65%'],
              center: ["50%", "50%"],
              label: {
                normal: {
                  show: false
                }
              },
              data: [{
                value: 1,
              }],
              z: -1
            }]
          });
      })
      axios.get('/api/powermis/bigScreen/getGeneratingCapacityTrend').then(response => {
        let _self = this;
        //实际发电量
        var actualGeneration = [];
        //发电量任务
        var generationTask = [];

        for (var i = 0; i < response.data.data.poweGenerationTrend.length; i++) {
          actualGeneration.push(response.data.data.poweGenerationTrend[i].actualGeneration)
          generationTask.push(response.data.data.poweGenerationTrend[i].generationTask)
        }

        // 绘制图表
        myChart2.setOption(
          {
            grid: {
              top: "25%",
              left: '12%',
              bottom: "15%"//也可设置left和right设置距离来控制图表的大小
            },
            color: ["#7179CB"],
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
                label: {
                  show: true
                }
              }
            },
            // backgroundColor: '#0f375f',
            legend: {
              data: ['发电量任务', '实际发电量'],
              textStyle: {
                color: '#ffffff'
              },
              bottom: -6
            },
            xAxis: {
              data: [
                "1月",
                "2月",
                "3月",
                "4月",
                "5月",
                "6月",
                "7月",
                "8月",
                "9月",
                "10月",
                "11月",
                "12月",
              ],
              axisLine: {
                show: false, //隐藏X轴轴线
                lineStyle: {
                  color: '#01FCE3'
                }
              },
              axisTick: {
                show: false //隐藏X轴刻度
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: "#ebf8ac" //X轴文字颜色
                },
                interval: 0, //坐标刻度之间的显示间隔，默认就可以了（默认是不重叠）
                rotate: 38   //调整数值改变倾斜的幅度（范围-90到90）
              },

            },
            yAxis: {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: '#ccc'
                }
              }
            },
            series: [{
              name: '实际发电量趋势',
              type: 'line',
              smooth: true,
              showAllSymbol: true,
              symbol: 'emptyCircle',
              symbolSize: 12,
              data: actualGeneration,
              label: {
                formatter: function (params) {
                  let thisData = params.data;
                  let generationData = generationTask[params.dataIndex];
                  if(thisData == 0 || generationData==0){
                     return "0%";
                  }
                  let str = (thisData / generationData * 100).toFixed(0);
                  return str + "%";
                },
                show: true,
                position: "top",
                textStyle: {
                  fontWeight: "bolder",
                  fontSize: "10",
                  color: "#fff"
                }
              },

            }, {
              name: '实际发电量',
              type: 'bar',
              barWidth: 15,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "#00FFE3"
                  },
                  {
                    offset: 1,
                    color: "#4693EC"
                  }
                  ])
                }
              },
              data: actualGeneration
            }, {
              name: '发电量任务',
              type: 'bar',
              barGap: '-100%',
              barWidth: 15,
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                    offset: 0,
                    color: "rgba(180, 180, 180, 0.2)"
                  },
                  {
                    offset: 1,
                    color: "rgba(180, 180, 180, 0.2)"
                  }
                  ])
                }
              },
              z: -12,
              data: generationTask
            }]
          }
        )
      })
    },
    /**
    * 校验只要是数字（包含正负整数，0以及正负浮点数）就返回true
    **/
    isNumber(val) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) && regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    },
    // 设置文字滚动
    setNumberTransform() {
      const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum.filter(item => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
  }
}
</script>

<style lang="scss" scoped="" type="text/css">
.progressImg {
  margin-top: -21px;
  img {
    width: 7px;
    height: 7px;
  }
}
.progress {
  border: 1px solid #68fbda;
  height: 8px;
  width: 85%;
  margin: 8% auto;
  border-radius: 7px;
}
.progress div {
  background-image: linear-gradient(to right, #467188, #81cdf3);
  width: 81%;
  height: 8px;
  border-radius: 7px;
}
.pig div:nth-child(1) {
  color: white;
  text-align: center;
  padding-top: 17px;
  background-image: -webkit-linear-gradient(top, #e8ffff, #6fdfe9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 24px;
  font-family: Hiragino Sans GB;
  font-weight: 900;
}
.workOrder {
  width: 26.27%;
  margin-left: 1.33%;
}
.header {
  display: flex;
}
.context1 {
  width: 36%;
}
.msg1 {
  height: 135px;
  background-color: #0a233d;
  text-align: center;
  margin-top: 17%;
  color: white;
  font-size: 21px;
  padding-top: 22px;
  .title {
    background-image: -webkit-linear-gradient(top, #e8ffff, #6fdfe9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 1.1vw;
    font-family: Hiragino Sans GB;
    font-weight: 900;
    color: rgba(255, 255, 255, 1);
  }
}
.chartNum {
  margin-top: 12px;
}
.msg2 {
  height: 155px;
  background-color: #0a233d;
  text-align: center;
  margin-top: 17%;
  color: white;
  font-size: 21px;
  padding-top: 22px;
  .title {
    background-image: -webkit-linear-gradient(top, #e8ffff, #6fdfe9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 1.1vw;
    font-family: Hiragino Sans GB;
    font-weight: 900;
    color: rgba(255, 255, 255, 1);
  }
}

.pig {
  width: 77%;
  margin-left: 2%;
  margin-top: 5%;
  background-color: #021326;
}
.pig img {
  width: 100%;
}
.workOrder_footer {
  width: 100%;
  background: url(../assets/orderDistribution.png) no-repeat;
  background-size: 100% 100%;
  height: 435px;
  margin-top: 9%;
  padding-left: 4%;
}
.chartNumBian {
  border: 1px solid #23898b;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 79%;
  margin: 0 auto;
  padding: 2%;
  border-radius: 7px;
  -webkit-box-shadow: 0px 0px 15px #187d86 inset, 0px 0px 7px #fff inset;
  box-shadow: 0px 0px 15px #187d86 inset, 0px 0px 7px #fff inset;
}
.box-item {
  position: relative;
  font-size: 15px;
  text-align: center;
  list-style: none;
  color: #fff;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
  margin: 0 auto;
  width: 100%;
  display: flex;
  line-height: 37px;
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 48px;
  position: relative;
  & > span {
    position: absolute;
    width: 100%;
    bottom: 0;
    writing-mode: vertical-rl;
    text-orientation: upright;
  }
}
/*滚动数字设置*/
.number-item {
  width: 22.9%;
  height: 37px;
  font-size: 18px;
  /* 背景图片 */
  background: url(../assets/text-bg-blue.png) no-repeat center center;
  background-size: 100% 100%;
  // background: #ccc;
  list-style: none;
  margin-right: 3px;
  // background:rgba(250,250,250,1);
  border-radius: 4px;
  font-weight: 900;
  & > i {
    font-style: normal;
    position: absolute;
    top: 11px;
    left: 50%;
    transform: translate(-50%, 0);
    transition: transform 1s ease-in-out;
    letter-spacing: 10px;
  }
}
.number-item:last-child {
  margin-right: 0;
}
#myChart2 {
  margin: 0 auto;
  padding-top: 1%;
  padding-left: 2%;
}
.progressWork {
  font-size: 12px;
  margin-top: -4px;
  span {
    color: #fcc215;
  }
}
.commas {
  margin: 0 auto !important;
  text-align: center;
}
.edit {
  color: white;
  position: absolute;
  margin-left: 11.5%;
  cursor: pointer;
  margin-top: -27px;
  font-size: 20px;
}
.edit2 {
  color: white;
  position: absolute;
  margin-left: 18.5%;
  cursor: pointer;
  font-size: 20px;
  margin-top: -18px;
}
</style>


// WEBPACK FOOTER //
// src/components/workOrder.vue